import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import {ReactComponent as Card} from "../../../../static/ic-credit-card-menu.svg";
import { isEmpty } from 'lodash'

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    if (!this.props.OrderListError && !this.props.OrderListLoading && this.props.OrderList.length == 0 ) {
      return (
        <div className="NoOrderContainer">
          <div className="NoOrderInner mrb90">
            {/* <img src={box} className="NoOrderbox" /> */}
            <Card  className="NoOrderbox NoTransactionCard" />
            <span className="NoOrderTitle">
              {" "}
              <Trans i18nKey={"NoTransaction"}> </Trans>{" "}
            </span>
            <span className="NoOrderDescription">
              {" "}
              <Trans i18nKey={"Historyofyourransactionswillbehere"}>
                {" "}
              </Trans>{" "}
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  open: state.Transactions.OpenDialoge,
  OrderList: state.Transactions.OrderList,
  OrderListLoading: state.Transactions.OrderListLoading,
  OrderListError: state.Transactions.OrderListError,
  page: state.Transactions.page,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
